module.exports = __webpack_public_path__ + "img/Map.3a94eea1.png";